import { type GenericListQueryKey, generateInfiniteQueryKey, generateListQueryKey } from '@pba/react-query';
import { medicalGroupsFeatureKey } from '../key';
import type { MedicalGroupsListQueryFilter, MedicalGroupsListQuerySorter } from './types';

type MedicalGroupsListQueryType = GenericListQueryKey<MedicalGroupsListQueryFilter, MedicalGroupsListQuerySorter>;

export const getMedicalGroupsListQueryKey = (params: MedicalGroupsListQueryType) =>
  generateListQueryKey({
    prefix: medicalGroupsFeatureKey,
  })(params);

export const getMedicalGroupsInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getMedicalGroupsListQueryKey,
});
